import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Page from 'components/Page';
import Checklist from 'components/onboarding/Checklist';
import HelpCard from 'components/onboarding/HelpCard';
import DocsCard from 'components/onboarding/DocsCard';

function Home() {
  const classes = useStyles();
  const personName = useSelector(state => _get(state, 'authentication.person.firstName'));
  const isTrial = useSelector(state => _get(state, ['client', 'isTrial']));

  useEffect(() => {
    document.title = 'Home';
  }, []);

  return (
    <Page classes={classes}>
      <Typography className={classes.heading}>Hi, {personName}</Typography>
      <Typography className={classes.message} variant="body2">
        Welcome to Sift! On this page you can learn how to set up and roll out Sift, reach out to
        our team if you need assistance, and view links to our documentation.
      </Typography>
      <Paper className={classes.paper} elevation={2}>
        <Checklist isOnHomePage />
      </Paper>
      <div className={classes.supportCardContainer}>
        <HelpCard isTrial={isTrial} />
        <DocsCard />
      </div>
    </Page>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  heading: {
    // @ts-ignore
    ...theme.typography.h5Semibold,
  },
  message: {
    // @ts-ignore
    color: theme.colors.gray2,
    maxWidth: 900,
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(3),
  },
  supportCardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
  },
  paper: {
    width: 900,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default Home;
